import { HHBox } from '@hinge-health/react-component-library';
import { useState } from 'react';
import { ConfigDetailsView } from './config-details-view';
import { NewProviderForm } from './new-provider-form';
import { ProviderConfigsView } from './provider-config-view';
import { ProviderDashboard } from './provider-dashboard';
import { ProviderRuleJsonView } from './provider-rule-json-view';

type ViewMode = 'dashboard' | 'provider-rules' | 'rule-details' | 'rule-json';

export const ClaimsIngestionView = (): JSX.Element => {
  const [viewMode, setViewMode] = useState<ViewMode>('dashboard');
  const [selectedProvider, setSelectedProvider] = useState<string | null>(null);
  const [selectedRuleId, setSelectedRuleId] = useState<string | null>(null);
  const [isNewProviderModalOpen, setIsNewProviderModalOpen] = useState(false);

  const handleProviderClick = (source: string): void => {
    setSelectedProvider(source);
    setViewMode('provider-rules');
  };

  const handleRuleClick = (ruleId: string): void => {
    setSelectedRuleId(ruleId);
    setViewMode('rule-details');
  };

  const handleViewJson = (): void => {
    setViewMode('rule-json');
  };

  const handleBackToDashboard = (): void => {
    setViewMode('dashboard');
    setSelectedProvider(null);
    setSelectedRuleId(null);
  };

  const handleBackToRules = (): void => {
    setViewMode('provider-rules');
    setSelectedRuleId(null);
  };

  const handleBackToDetails = (): void => {
    setViewMode('rule-details');
  };

  const handleCreateNewProvider = (): void => {
    setIsNewProviderModalOpen(true);
  };

  const handleCloseNewProviderModal = (): void => {
    setIsNewProviderModalOpen(false);
  };

  const handleNewProviderSuccess = (_providerName: string): void => {
    setIsNewProviderModalOpen(false);
    // Dashboard should refresh to show the new provider
  };

  return (
    <HHBox>
      {viewMode === 'dashboard' && (
        <ProviderDashboard
          onProviderClick={handleProviderClick}
          onCreateNewProvider={handleCreateNewProvider}
        />
      )}

      {viewMode === 'provider-rules' && selectedProvider && (
        <ProviderConfigsView
          providerSource={selectedProvider}
          onBack={handleBackToDashboard}
          onRuleClick={handleRuleClick}
        />
      )}

      {viewMode === 'rule-details' && selectedRuleId && (
        <ConfigDetailsView
          ruleId={selectedRuleId}
          onBack={handleBackToRules}
          onViewJson={handleViewJson}
        />
      )}

      {viewMode === 'rule-json' && selectedRuleId && (
        <ProviderRuleJsonView
          ruleId={selectedRuleId}
          onBack={handleBackToDetails}
        />
      )}

      {/* New Provider Modal */}
      <NewProviderForm
        open={isNewProviderModalOpen}
        onClose={handleCloseNewProviderModal}
        onSuccess={handleNewProviderSuccess}
      />
    </HHBox>
  );
};
